import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    class="cui5-icon cui5-icon--color-undefined undefined">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-.72 16v-1.04c-.67-.1-1.2-.32-1.6-.58-.5-.33-.77-.71-.92-.94-.22-.35-.1-.82.24-1.03.35-.22.82-.12 1.04.24.07.12.2.3.47.48.25.16.68.34 1.37.38h.13c1.23-.04 1.84-.77 1.84-1.39 0-.2-.04-.32-.1-.42-.06-.12-.17-.25-.4-.43-.36-.28-.63-.36-1.22-.55l-.28-.1-.37-.1-.1-.02c-.17-.04-.38-.1-.6-.19-.25-.1-.51-.23-.7-.34-.13-.07-.26-.15-.38-.24-.33-.25-.6-.54-.79-.9-.19-.37-.26-.75-.26-1.15 0-1.46 1.18-2.49 2.6-2.8V6c0-.41.34-.75.75-.75s.75.34.75.75v.85c.66.1 1.17.31 1.57.57.5.33.77.72.92.94.22.35.1.82-.24 1.04-.35.22-.82.1-1.04-.24-.07-.12-.2-.31-.47-.48-.25-.17-.68-.35-1.37-.39H12c-1.22.05-1.86.8-1.86 1.39 0 .22.04.35.1.46.05.1.15.23.34.39l.04.03.2.1c.16.1.34.2.5.26.13.05.26.09.43.13l.08.02.47.13.27.08c.58.19 1.11.36 1.7.81.31.25.59.52.79.87.2.36.28.75.28 1.16 0 1.45-1.15 2.5-2.57 2.8V18c0 .41-.34.75-.75.75-.42 0-.75-.34-.75-.75Z"></path>
  </svg>
);

const PipedriveDealsIcon = (props) => <Icon component={svg} {...props} />;

export default PipedriveDealsIcon;
